<template>
  <Section>
    <template v-slot:section-header>
      <h5 class="header-title">จัดเรียงเพลย์ลิสต์รายการ</h5>
    </template>
    <template v-slot:section-body>
      <draggable class="row" v-model="playlists">
        <div
          class="playlist-container col-md-4"
          v-for="(item, itemIndex) in playlists"
          :key="itemIndex">
          <div class="playlist">
            <div class="cover-image">
              <ImageView
                :source="item.coverImage" />
            </div>
            <div class="information-container">
              <div class="information">
                <h6 class="title">{{item.title}}</h6>
                <small class="update-time">{{formatDateTime(item.updatedAt)}}</small>
              </div>
              <div class="badge badge-status" :class="item.status">
                {{ item.status }}
              </div>
            </div>
          </div>
        </div>
      </draggable>
      <EmptyMessage v-if="playlists && !playlists.length">
        <div class="empty-message">รายการนี้ยังไม่มีเพลย์ลิสต์</div>
        <router-link
          class="btn btn-light mt-3"
          target="_blank"
          :to="'/collections?type=video'">
          เลือกเพลย์ลิสต์ของรายการ
        </router-link>
      </EmptyMessage>
      <EmptyMessage v-if="!playlists">
        <div class="empty-message">คุณสามารถจัดเรียงเพลย์ลิสต์ได้หลังจากสร้างรายการเสร็จแล้ว</div>
      </EmptyMessage>
    </template>
  </Section>
</template>

<script>
import _ from 'lodash';
import draggable from 'vuedraggable';
import { mapState } from 'vuex';
import Section from '@/components/Section.vue';
import ImageView from '@/image/ImageView.vue';
import dateFormatter from '@/utils/dateFormatter';
import EmptyMessage from '@/components/EmptyMessage.vue';

export default {
  mixins: [dateFormatter],
  components: {
    Section,
    draggable,
    ImageView,
    EmptyMessage,
  },
  computed: {
    ...mapState({
      currentProgram: (state) => state.programItem.currentProgram,
    }),
  },
  data() {
    return {
      playlists: [],
    };
  },
  created() {
    this.playlists = _.cloneDeep(this.currentProgram.playlists);
  },
  watch: {
    playlists(newPlaylists) {
      if (newPlaylists) {
        const playlistIds = newPlaylists.map((playlist) => playlist.id);
        this.$store.dispatch('setCurrentProgram', { playlists: this.playlists, playlistIds });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/section-container.scss';

.header-title {
  font-weight: normal;
  font-size: 1.09375rem;
  margin-bottom: 0;
}

.playlist {
  padding: $spacer;
  border-radius: 4px;
  /* background: #f5f5f5; */
  box-shadow: 1px 3px 7px rgba(62, 55, 55, 0.3);
  margin-bottom: $spacer;
  cursor: move;

  .information-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: $spacer;
  }

  // .title {
  //   margin-top: $spacer;
  // }
}

.empty-message {
  font-size: $h5-font-size;
}

</style>
